// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournamentDetailsCardContainer {
    width: 100%;
    display: flex;
    justify-content: start;
    flex-direction: column;
    gap: 16px;
  }
  
  .tournamentDetailsCardContainer p {
    padding: 0px 20px;
    color: #fff;
    font-family: Lato;
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 100%; /* 12px */
  }

  .tournamentDetailsCardSlider{
    padding: 0px 20px;
    max-width: 100%;
    width: 100%;
    display: flex;
    flex-wrap: nowrap;
    overflow-x: auto;
    gap: 8px;
    padding-bottom: 8px;
  }

  
  .tournamentDetailsCardWraper {
    display: flex;
    border-radius: 12px;
    background: #C3D32C;
    min-width: 100%;
    padding: 12px 16px;
    border-radius: 12px;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    gap: 12px;
  }

  .tournamentDetailsCardWraper ul{
    width: 100%;
    display: flex;
    flex-direction: column;
    list-style: none;
    font-size: 16px;
    gap: 12px;
    color: black;
  }
  
  .tournamentDetailsCardWraper ul li{
    width: 100%;
    display: flex;
    list-style: none;
    font-size: 16px;
    justify-content: space-between;
    align-items: center;
    color: black;
  }

  .tournamentDetailsCardWraper ul li p{
    list-style: none;
    font-size: 16px;
    padding: 0;
    font-family: Lato;
    color: black;
  }`, "",{"version":3,"sources":["webpack://./src/components/Tournament/TournamentDetailsCard.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;EAC9B;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,gBAAgB;IAChB,QAAQ;IACR,mBAAmB;EACrB;;;EAGA;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,SAAS;IACT,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,UAAU;IACV,iBAAiB;IACjB,YAAY;EACd","sourcesContent":[".tournamentDetailsCardContainer {\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: start;\r\n    flex-direction: column;\r\n    gap: 16px;\r\n  }\r\n  \r\n  .tournamentDetailsCardContainer p {\r\n    padding: 0px 20px;\r\n    color: #fff;\r\n    font-family: Lato;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: 700;\r\n    line-height: 100%; /* 12px */\r\n  }\r\n\r\n  .tournamentDetailsCardSlider{\r\n    padding: 0px 20px;\r\n    max-width: 100%;\r\n    width: 100%;\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n    overflow-x: auto;\r\n    gap: 8px;\r\n    padding-bottom: 8px;\r\n  }\r\n\r\n  \r\n  .tournamentDetailsCardWraper {\r\n    display: flex;\r\n    border-radius: 12px;\r\n    background: #C3D32C;\r\n    min-width: 100%;\r\n    padding: 12px 16px;\r\n    border-radius: 12px;\r\n    justify-content: center;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 12px;\r\n  }\r\n\r\n  .tournamentDetailsCardWraper ul{\r\n    width: 100%;\r\n    display: flex;\r\n    flex-direction: column;\r\n    list-style: none;\r\n    font-size: 16px;\r\n    gap: 12px;\r\n    color: black;\r\n  }\r\n  \r\n  .tournamentDetailsCardWraper ul li{\r\n    width: 100%;\r\n    display: flex;\r\n    list-style: none;\r\n    font-size: 16px;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    color: black;\r\n  }\r\n\r\n  .tournamentDetailsCardWraper ul li p{\r\n    list-style: none;\r\n    font-size: 16px;\r\n    padding: 0;\r\n    font-family: Lato;\r\n    color: black;\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
